import React from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

// ============================================================================
// Component
// ============================================================================

export function InteractiveMapSection() {
  const mapSlot = useBlockSlot('interactivemapsection.map_block', {
    defaultValue: 'apartment-sync-map',
  });

  return (
    <EditableToken path="interactivemapsection.map_block" as="div">
      {mapSlot ? (
        <SectionContextProvider sectionId={mapSlot.sectionId}>
          <mapSlot.BlockComponent sectionId={mapSlot.sectionId} />
        </SectionContextProvider>
      ) : (
        <div>No block selected</div>
      )}
    </EditableToken>
  );
}

// ============================================================================
// Schema
// ============================================================================

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapSection',
  displayName: 'Interactive Map Section',
  tokens: {
    'interactivemapsection.map_block': {
      label: 'Map Block',
      type: 'block',
      defaultValue: 'apartment-sync-map',
      acceptedBlockCategories: ['Integrations'],
    },
  },
  slotGroups: {},
  collectionBindings: {},
};

(InteractiveMapSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default InteractiveMapSection;
